// DO NOT MODIFY BY HAND!!
// Go through Readme.md

import React from 'react';
import { APPalette } from '../utils';

import { ReactComponent as InflationGraph } from './icon-inflationGraph.svg';
import { ReactComponent as InsurancePerson } from './icon-insurancePerson.svg';
import { ReactComponent as SendMessage } from './icon-sendMessage.svg';
import { ReactComponent as ActivityLine } from './activity_line.svg';
import { ReactComponent as AlertTriangleSolid } from './alert-triangle_solid.svg';
import { ReactComponent as AnchorLine } from './anchor_line.svg';
import { ReactComponent as AnnouncementSolid } from './announcement_solid.svg';
import { ReactComponent as ArchiveSolid } from './archive_solid.svg';
import { ReactComponent as ArrowCircleBrokenDownLine } from './arrow-circle-broken-down_line.svg';
import { ReactComponent as ArrowCircleBrokenDownSolid } from './arrow-circle-broken-down_solid.svg';
import { ReactComponent as ArrowCircleBrokenLeftLine } from './arrow-circle-broken-left_line.svg';
import { ReactComponent as ArrowCircleBrokenLeftSolid } from './arrow-circle-broken-left_solid.svg';
import { ReactComponent as ArrowCircleBrokenRightLine } from './arrow-circle-broken-right_line.svg';
import { ReactComponent as ArrowCircleBrokenRightSolid } from './arrow-circle-broken-right_solid.svg';
import { ReactComponent as ArrowCircleBrokenUpLeftLine } from './arrow-circle-broken-up-left_line.svg';
import { ReactComponent as ArrowCircleBrokenUpLeftSolid } from './arrow-circle-broken-up-left_solid.svg';
import { ReactComponent as ArrowCircleBrokenUpRightLine } from './arrow-circle-broken-up-right_line.svg';
import { ReactComponent as ArrowCircleBrokenUpRightSolid } from './arrow-circle-broken-up-right_solid.svg';
import { ReactComponent as ArrowCircleBrokenUpLine } from './arrow-circle-broken-up_line.svg';
import { ReactComponent as ArrowCircleBrokenUpSolid } from './arrow-circle-broken-up_solid.svg';
import { ReactComponent as ArrowCircleDownLeftLine } from './arrow-circle-down-left_line.svg';
import { ReactComponent as ArrowCircleDownLeftSolid } from './arrow-circle-down-left_solid.svg';
import { ReactComponent as ArrowCircleDownRightLine } from './arrow-circle-down-right_line.svg';
import { ReactComponent as ArrowCircleDownRightSolid } from './arrow-circle-down-right_solid.svg';
import { ReactComponent as ArrowCircleDownLine } from './arrow-circle-down_line.svg';
import { ReactComponent as ArrowCircleLeftLine } from './arrow-circle-left_line.svg';
import { ReactComponent as ArrowCircleLeftSolid } from './arrow-circle-left_solid.svg';
import { ReactComponent as ArrowCircleRightLine } from './arrow-circle-right_line.svg';
import { ReactComponent as ArrowCircleRightSolid } from './arrow-circle-right_solid.svg';
import { ReactComponent as ArrowCircleUpLine } from './arrow-circle-up_line.svg';
import { ReactComponent as ArrowNarrowDownLeftLine } from './arrow-narrow-down-left_line.svg';
import { ReactComponent as ArrowNarrowDownRightLine } from './arrow-narrow-down-right_line.svg';
import { ReactComponent as ArrowNarrowRightLine } from './arrow-narrow-right_line.svg';
import { ReactComponent as ArrowNarrowUpLeftLine } from './arrow-narrow-up-left_line.svg';
import { ReactComponent as ArrowNarrowUpRightLine } from './arrow-narrow-up-right_line.svg';
import { ReactComponent as ArrowSquareDownLine } from './arrow-square-down_line.svg';
import { ReactComponent as ArrowSquareDownSolid } from './arrow-square-down_solid.svg';
import { ReactComponent as ArrowSquareLeftLine } from './arrow-square-left_line.svg';
import { ReactComponent as ArrowSquareLeftSolid } from './arrow-square-left_solid.svg';
import { ReactComponent as ArrowSquareRightLine } from './arrow-square-right_line.svg';
import { ReactComponent as ArrowSquareRightSolid } from './arrow-square-right_solid.svg';
import { ReactComponent as ArrowSquareUpLine } from './arrow-square-up_line.svg';
import { ReactComponent as ArrowSquareUpSolid } from './arrow-square-up_solid.svg';
import { ReactComponent as Asterisk01Line } from './asterisk-01_line.svg';
import { ReactComponent as Asterisk02Line } from './asterisk-02_line.svg';
import { ReactComponent as AtSignLine } from './at-sign_line.svg';
import { ReactComponent as BankSolid } from './bank_solid.svg';
import { ReactComponent as BarChartSolid } from './bar-chart_solid.svg';
import { ReactComponent as BookClosedSolid } from './book-closed_solid.svg';
import { ReactComponent as BookmarkAddLine } from './bookmark-add_line.svg';
import { ReactComponent as BookmarkAddSolid } from './bookmark-add_solid.svg';
import { ReactComponent as BookmarkCheckLine } from './bookmark-check_line.svg';
import { ReactComponent as BookmarkCheckSolid } from './bookmark-check_solid.svg';
import { ReactComponent as BookmarkMinusLine } from './bookmark-minus_line.svg';
import { ReactComponent as BookmarkMinusSolid } from './bookmark-minus_solid.svg';
import { ReactComponent as BookmarkXLine } from './bookmark-x_line.svg';
import { ReactComponent as BookmarkXSolid } from './bookmark-x_solid.svg';
import { ReactComponent as BookmarkSolid } from './bookmark_solid.svg';
import { ReactComponent as BriefcaseSolid } from './briefcase_solid.svg';
import { ReactComponent as Building01Line } from './building-01_line.svg';
import { ReactComponent as Building01Solid } from './building-01_solid.svg';
import { ReactComponent as Building02Line } from './building-02_line.svg';
import { ReactComponent as Building02Solid } from './building-02_solid.svg';
import { ReactComponent as CalculatorSolid } from './calculator_solid.svg';
import { ReactComponent as CalendarDateSolid } from './calendar-date_solid.svg';
import { ReactComponent as CameraSolid } from './camera_solid.svg';
import { ReactComponent as ChatCircleSolid } from './chat-circle_solid.svg';
import { ReactComponent as ChevronSelectorVertical } from './chevron-selector-vertical.svg';
import { ReactComponent as CircleChevronDownSolid } from './circle-chevron-down_solid.svg';
import { ReactComponent as CircleChevronLeftSolid } from './circle-chevron-left_solid.svg';
import { ReactComponent as CircleChevronRightSolid } from './circle-chevron-right_solid.svg';
import { ReactComponent as CircleChevronUpSolid } from './circle-chevron-up_solid.svg';
import { ReactComponent as CircleSwitchHorizontal01Solid } from './circle-switch-horizontal-01_solid.svg';
import { ReactComponent as CircleSwitchHorizontal02Solid } from './circle-switch-horizontal-02_solid.svg';
import { ReactComponent as CircleSwitchVertical02Solid } from './circle-switch-vertical-02_solid.svg';
import { ReactComponent as ClockSolid } from './clock_solid.svg';
import { ReactComponent as CoinsHandSolid } from './coins-hand_solid.svg';
import { ReactComponent as CoinsStackedSolid } from './coins-stacked_solid.svg';
import { ReactComponent as CopySolid } from './copy_solid.svg';
import { ReactComponent as DeleteSolid } from './delete_solid.svg';
import { ReactComponent as Edit01Solid } from './edit-01_solid.svg';
import { ReactComponent as EyeOffSolid } from './eye-off_solid.svg';
import { ReactComponent as EyeSolid } from './eye_solid.svg';
import { ReactComponent as FileAttachmentSolid } from './file-attachment_solid.svg';
import { ReactComponent as FileChartSolid } from './file-chart_solid.svg';
import { ReactComponent as FileDownloadSolid } from './file-download_solid.svg';
import { ReactComponent as FileSolid } from './file_solid.svg';
import { ReactComponent as FolderSolid } from './folder_solid.svg';
import { ReactComponent as GiftSolid } from './gift_solid.svg';
import { ReactComponent as GraduationHatSolid } from './graduation-hat_solid.svg';
import { ReactComponent as GridSolid } from './grid_solid.svg';
import { ReactComponent as HelpCircleLine } from './help-circle_line.svg';
import { ReactComponent as HourglassSolid } from './hourglass_solid.svg';
import { ReactComponent as AdvisorFilled } from './icon-advisor-filled.svg';
import { ReactComponent as AdvisorOutline } from './icon-advisor-outline.svg';
import { ReactComponent as AlertOctagon } from './icon-alertOctagon.svg';
import { ReactComponent as Amessage } from './icon-amessage.svg';
import { ReactComponent as Archive } from './icon-archive.svg';
import { ReactComponent as ArrowDown } from './icon-arrowDown.svg';
import { ReactComponent as ArrowUp } from './icon-arrowUp.svg';
import { ReactComponent as Assetplus } from './icon-assetplus.svg';
import { ReactComponent as AttachFile } from './icon-attach-file.svg';
import { ReactComponent as Attachment } from './icon-attachment.svg';
import { ReactComponent as Bank } from './icon-bank.svg';
import { ReactComponent as BarChart01 } from './icon-barChart01.svg';
import { ReactComponent as BarChart02 } from './icon-barChart02.svg';
import { ReactComponent as Bold } from './icon-bold.svg';
import { ReactComponent as Bond } from './icon-bond.svg';
import { ReactComponent as Book } from './icon-book.svg';
import { ReactComponent as Bookmark } from './icon-bookmark.svg';
import { ReactComponent as Briefcase } from './icon-briefcase.svg';
import { ReactComponent as Bulb } from './icon-bulb.svg';
import { ReactComponent as Calculator } from './icon-calculator.svg';
import { ReactComponent as Calendar } from './icon-calendar.svg';
import { ReactComponent as Camera } from './icon-camera.svg';
import { ReactComponent as CartFilled } from './icon-cart-filled.svg';
import { ReactComponent as CartOutline } from './icon-cart-outline.svg';
import { ReactComponent as Celebrate } from './icon-celebrate.svg';
import { ReactComponent as Chat } from './icon-chat.svg';
import { ReactComponent as CheckCircle } from './icon-check-circle.svg';
import { ReactComponent as ClockWarning } from './icon-clock-warning.svg';
import { ReactComponent as CheckIntense } from './icon-check-intense.svg';
import { ReactComponent as Check } from './icon-check.svg';
import { ReactComponent as CheckOutline } from './icon-checkOutline.svg';
import { ReactComponent as Checklist } from './icon-checklist.svg';
import { ReactComponent as ChevronUpDouble } from './icon-chevron-up-double.svg';
import { ReactComponent as CircleOutline } from './icon-circleOutline.svg';
import { ReactComponent as ClappingFilled } from './icon-clapping-filled.svg';
import { ReactComponent as Clapping } from './icon-clapping.svg';
import { ReactComponent as Clock } from './icon-clock.svg';
import { ReactComponent as Close } from './icon-close.svg';
import { ReactComponent as CloseOutline } from './icon-closeOutline.svg';
import { ReactComponent as CoinsStacked } from './icon-coins-stacked.svg';
import { ReactComponent as ConsultFilled } from './icon-consult-filled.svg';
import { ReactComponent as ConsultOutline } from './icon-consult-outline.svg';
import { ReactComponent as Copy } from './icon-copy.svg';
import { ReactComponent as CopyNew } from './icon-copy_new.svg';
import { ReactComponent as CopyRights } from './icon-copy_rights.svg';
import { ReactComponent as CreditCard } from './icon-credit-card.svg';
import { ReactComponent as CrossMark } from './icon-cross-mark.svg';
import { ReactComponent as Delete } from './icon-delete.svg';
import { ReactComponent as Document } from './icon-document.svg';
import { ReactComponent as DotPoints } from './icon-dot-points.svg';
import { ReactComponent as DoubleCheck } from './icon-double-check.svg';
import { ReactComponent as DownRound } from './icon-down-round.svg';
import { ReactComponent as Down } from './icon-down.svg';
import { ReactComponent as DownloadArrow } from './icon-download-arrow.svg';
import { ReactComponent as Download } from './icon-download.svg';
import { ReactComponent as Drag } from './icon-drag.svg';
import { ReactComponent as Edit } from './icon-edit.svg';
import { ReactComponent as ErrorOutline } from './icon-error-outline.svg';
import { ReactComponent as Error } from './icon-error.svg';
import { ReactComponent as Event } from './icon-event.svg';
import { ReactComponent as Excel } from './icon-excel.svg';
import { ReactComponent as ExchangeFunds } from './icon-exchange_funds.svg';
import { ReactComponent as EyeOff } from './icon-eye-off.svg';
import { ReactComponent as Eye } from './icon-eye.svg';
import { ReactComponent as Faq } from './icon-faq.svg';
import { ReactComponent as FavFilled } from './icon-fav-filled.svg';
import { ReactComponent as FavOutline } from './icon-fav-outline.svg';
import { ReactComponent as FileAttachment } from './icon-fileAttachment.svg';
import { ReactComponent as Filter } from './icon-filter.svg';
import { ReactComponent as Folder } from './icon-folder.svg';
import { ReactComponent as FundFinder } from './icon-fundFinder.svg';
import { ReactComponent as Generate } from './icon-generate.svg';
import { ReactComponent as Gift } from './icon-gift.svg';
import { ReactComponent as GraduationHat } from './icon-graduation-hat.svg';
import { ReactComponent as Grid } from './icon-grid.svg';
import { ReactComponent as HandCoin } from './icon-handCoin.svg';
import { ReactComponent as HeartOutline } from './icon-heartOutline.svg';
import { ReactComponent as History } from './icon-history.svg';
import { ReactComponent as HomeFilled } from './icon-home-filled.svg';
import { ReactComponent as HomeOutline } from './icon-home-outline.svg';
import { ReactComponent as HorizontalMore } from './icon-horizontalMore.svg';
import { ReactComponent as Hourglass } from './icon-hourglass.svg';
import { ReactComponent as Image } from './icon-image.svg';
import { ReactComponent as Inbox } from './icon-inbox.svg';
import { ReactComponent as Income } from './icon-income.svg';
import { ReactComponent as Indicator } from './icon-indicator.svg';
import { ReactComponent as InfoIntense } from './icon-info-intense.svg';
import { ReactComponent as InfoSubtle } from './icon-info-subtle.svg';
import { ReactComponent as Info } from './icon-info.svg';
import { ReactComponent as InsuranceFilled } from './icon-insurance-filled.svg';
import { ReactComponent as InsuranceOutline } from './icon-insurance-outline.svg';
import { ReactComponent as InvestFilled } from './icon-invest-filled.svg';
import { ReactComponent as InvestOutline } from './icon-invest-outline.svg';
import { ReactComponent as Italic } from './icon-italic.svg';
import { ReactComponent as JusticeScale } from './icon-justiceScale.svg';
import { ReactComponent as Language } from './icon-language.svg';
import { ReactComponent as Language02 } from './icon-language02.svg';
import { ReactComponent as Language1 } from './icon-language1.svg';
import { ReactComponent as Layers } from './icon-layers.svg';
import { ReactComponent as LeftArrow } from './icon-left-arrow.svg';
import { ReactComponent as Left } from './icon-left.svg';
import { ReactComponent as LikeFilled } from './icon-like-filled.svg';
import { ReactComponent as LineChart } from './icon-lineChart.svg';
import { ReactComponent as Link } from './icon-link.svg';
import { ReactComponent as List } from './icon-list.svg';
import { ReactComponent as Loader } from './icon-loader.svg';
import { ReactComponent as Loading } from './icon-loading.svg';
import { ReactComponent as Location } from './icon-location.svg';
import { ReactComponent as Lock } from './icon-lock.svg';
import { ReactComponent as LogOut } from './icon-logOut.svg';
import { ReactComponent as Loss } from './icon-loss.svg';
import { ReactComponent as Mail } from './icon-mail.svg';
import { ReactComponent as Marketing } from './icon-marketing.svg';
import { ReactComponent as Media2 } from './icon-media2.svg';
import { ReactComponent as MedicalCross } from './icon-medical-cross.svg';
import { ReactComponent as Message } from './icon-message.svg';
import { ReactComponent as Navigation } from './icon-navigation.svg';
import { ReactComponent as NegativeIntense } from './icon-negative-intense.svg';
import { ReactComponent as NegativeSubtle } from './icon-negative-subtle.svg';
import { ReactComponent as NoteTrash } from './icon-note-trash.svg';
import { ReactComponent as NotificationFilled } from './icon-notification-filled.svg';
import { ReactComponent as NotificationOutline } from './icon-notification-outline.svg';
import { ReactComponent as NotificationActiveFilled } from './icon-notificationActive-filled.svg';
import { ReactComponent as NotificationActiveOutline } from './icon-notificationActive-outline.svg';
import { ReactComponent as Passcode } from './icon-passcode.svg';
import { ReactComponent as Pdf } from './icon-pdf.svg';
import { ReactComponent as PencilFilled } from './icon-pencil-filled.svg';
import { ReactComponent as PencilOutline } from './icon-pencil-outline.svg';
import { ReactComponent as Phone } from './icon-phone.svg';
import { ReactComponent as Pin } from './icon-pin.svg';
import { ReactComponent as Play } from './icon-play.svg';
import { ReactComponent as Plus } from './icon-plus.svg';
import { ReactComponent as PlusCircle } from './icon-plusCircle.svg';
import { ReactComponent as PlusRounded } from './icon-plusRounded.svg';
import { ReactComponent as Podcast } from './icon-podcast.svg';
import { ReactComponent as Poster } from './icon-poster.svg';
import { ReactComponent as Ppt } from './icon-ppt.svg';
import { ReactComponent as ProfileDocument } from './icon-profile-document.svg';
import { ReactComponent as Profile } from './icon-profile.svg';
import { ReactComponent as Profit } from './icon-profit.svg';
import { ReactComponent as RadioOn } from './icon-radio-on.svg';
import { ReactComponent as RefreshDouble } from './icon-refresh-double.svg';
import { ReactComponent as Refresh } from './icon-refresh.svg';
import { ReactComponent as Report } from './icon-report.svg';
import { ReactComponent as Retirement } from './icon-retirement.svg';
import { ReactComponent as Right } from './icon-right.svg';
import { ReactComponent as RocketFilled } from './icon-rocket-filled.svg';
import { ReactComponent as RocketOutline } from './icon-rocket-outline.svg';
import { ReactComponent as Rupee } from './icon-rupee.svg';
import { ReactComponent as Save } from './icon-save.svg';
import { ReactComponent as Scales } from './icon-scales.svg';
import { ReactComponent as SearchRefraction } from './icon-search-refraction.svg';
import { ReactComponent as Search } from './icon-search.svg';
import { ReactComponent as Send } from './icon-send.svg';
import { ReactComponent as SettingsFilled } from './icon-settings-filled.svg';
import { ReactComponent as SettingsOutline } from './icon-settings-outline.svg';
import { ReactComponent as ShareTool } from './icon-share-tool.svg';
import { ReactComponent as Share } from './icon-share.svg';
import { ReactComponent as Share02 } from './icon-share02.svg';
import { ReactComponent as Shield } from './icon-shield.svg';
import { ReactComponent as Shop } from './icon-shop.svg';
import { ReactComponent as Sort } from './icon-sort.svg';
import { ReactComponent as Sparkles } from './icon-sparkles.svg';
import { ReactComponent as StarFilled } from './icon-star-filled.svg';
import { ReactComponent as StarOutline } from './icon-star-outline.svg';
import { ReactComponent as StrikeThrough } from './icon-strike-through.svg';
import { ReactComponent as SuperStarter } from './icon-super_starter.svg';
import { ReactComponent as Support } from './icon-support.svg';
import { ReactComponent as Switch } from './icon-switch.svg';
import { ReactComponent as Team } from './icon-team.svg';
import { ReactComponent as TickRound } from './icon-tick-round.svg';
import { ReactComponent as Tool01 } from './icon-tool-01.svg';
import { ReactComponent as Tool } from './icon-tool.svg';
import { ReactComponent as Trash } from './icon-trash.svg';
import { ReactComponent as Truck } from './icon-truck.svg';
import { ReactComponent as Umbrella } from './icon-umbrella.svg';
import { ReactComponent as Underline } from './icon-underline.svg';
import { ReactComponent as Unlock } from './icon-unlock.svg';
import { ReactComponent as UpRound } from './icon-up-round.svg';
import { ReactComponent as Up } from './icon-up.svg';
import { ReactComponent as Upload } from './icon-upload.svg';
import { ReactComponent as UserFilled } from './icon-user-filled.svg';
import { ReactComponent as UserOutline } from './icon-user-outline.svg';
import { ReactComponent as UserPlus } from './icon-user-plus.svg';
import { ReactComponent as UsersFilled } from './icon-users-filled.svg';
import { ReactComponent as UsersOutline } from './icon-users-outline.svg';
import { ReactComponent as Vault } from './icon-vault.svg';
import { ReactComponent as VerticalMore } from './icon-verticalMore.svg';
import { ReactComponent as Video } from './icon-video.svg';
import { ReactComponent as View } from './icon-view.svg';
import { ReactComponent as Wand } from './icon-wand.svg';
import { ReactComponent as WaringSubtle } from './icon-waring-subtle.svg';
import { ReactComponent as WarningIntense } from './icon-warning-intense.svg';
import { ReactComponent as Warning } from './icon-warning.svg';
import { ReactComponent as Webinar } from './icon-webinar.svg';
import { ReactComponent as Whatsapp } from './icon-whatsapp.svg';
import { ReactComponent as InboxSolid } from './inbox_solid.svg';
import { ReactComponent as InfoCircle } from './info-circle.svg';
import { ReactComponent as InfoSquareSolid } from './info-square_solid.svg';
import { ReactComponent as LayersThreeSolid } from './layers-three_solid.svg';
import { ReactComponent as LightbulbSolid } from './lightbulb_solid.svg';
import { ReactComponent as LockUnlockedSolid } from './lock-unlocked_solid.svg';
import { ReactComponent as LockSolid } from './lock_solid.svg';
import { ReactComponent as LogInLine } from './log-in_line.svg';
import { ReactComponent as MailSolid } from './mail_solid.svg';
import { ReactComponent as MarkerPinSolid } from './marker-pin_solid.svg';
import { ReactComponent as MenuLine } from './menu_line.svg';
import { ReactComponent as MessageChatSquareSolid } from './message-chat-square_solid.svg';
import { ReactComponent as MessageQuestionSquareSolid } from './message-question-square_solid.svg';
import { ReactComponent as MobilePhoneLine } from './mobile-phone_line.svg';
import { ReactComponent as MobilePhoneSolid } from './mobile-phone_solid.svg';
import { ReactComponent as MoonLine } from './moon_line.svg';
import { ReactComponent as MoonSolid } from './moon_solid.svg';
import { ReactComponent as PasscodeSolid } from './passcode_solid.svg';
import { ReactComponent as PauseSquareLine } from './pause-square_line.svg';
import { ReactComponent as PauseSquareSolid } from './pause-square_solid.svg';
import { ReactComponent as PhoneSolid } from './phone_solid.svg';
import { ReactComponent as PinSolid } from './pin_solid.svg';
import { ReactComponent as PlayLine } from './play_line.svg';
import { ReactComponent as PosterSolid } from './poster_solid.svg';
import { ReactComponent as RefreshCw01Line } from './refresh-cw-01_line.svg';
import { ReactComponent as SaveSolid } from './save_solid.svg';
import { ReactComponent as ScalesSolid } from './scales_solid.svg';
import { ReactComponent as SendSolid } from './send_solid.svg';
import { ReactComponent as Share02Solid } from './share-02_solid.svg';
import { ReactComponent as ShieldSolid } from './shield_solid.svg';
import { ReactComponent as SignalLine } from './signal_line.svg';
import { ReactComponent as SignalSolid } from './signal_solid.svg';
import { ReactComponent as SwitchHorizontal01Line } from './switch-horizontal-01_line.svg';
import { ReactComponent as SwitchVertical01Line } from './switch-vertical-01_line.svg';
import { ReactComponent as TargetSolid } from './target_solid.svg';
import { ReactComponent as Tool01Solid } from './tool-01_solid.svg';
import { ReactComponent as Tool02Solid } from './tool-02_solid.svg';
import { ReactComponent as TrashSolid } from './trash_solid.svg';
import { ReactComponent as TvSolid } from './tv_solid.svg';
import { ReactComponent as UmbrellaSolid } from './umbrella_solid.svg';
import { ReactComponent as VideoRecorderSolid } from './video-recorder_solid.svg';
import { ReactComponent as WhatsappSolid } from './whatsapp_solid.svg';

export type SVGIcon = "activityLine" | "alertTriangleSolid" | "anchorLine" | "announcementSolid" | "archiveSolid" | "arrowCircleBrokenDownLine" | "arrowCircleBrokenDownSolid" | "arrowCircleBrokenLeftLine" | "arrowCircleBrokenLeftSolid" | "arrowCircleBrokenRightLine" | "arrowCircleBrokenRightSolid" | "arrowCircleBrokenUpLeftLine" | "arrowCircleBrokenUpLeftSolid" | "arrowCircleBrokenUpRightLine" | "arrowCircleBrokenUpRightSolid" | "arrowCircleBrokenUpLine" | "arrowCircleBrokenUpSolid" | "arrowCircleDownLeftLine" | "arrowCircleDownLeftSolid" | "arrowCircleDownRightLine" | "arrowCircleDownRightSolid" | "arrowCircleDownLine" | "arrowCircleLeftLine" | "arrowCircleLeftSolid" | "arrowCircleRightLine" | "arrowCircleRightSolid" | "arrowCircleUpLine" | "arrowNarrowDownLeftLine" | "arrowNarrowDownRightLine" | "arrowNarrowRightLine" | "arrowNarrowUpLeftLine" | "arrowNarrowUpRightLine" | "arrowSquareDownLine" | "arrowSquareDownSolid" | "arrowSquareLeftLine" | "arrowSquareLeftSolid" | "arrowSquareRightLine" | "arrowSquareRightSolid" | "arrowSquareUpLine" | "arrowSquareUpSolid" | "asterisk01Line" | "asterisk02Line" | "atSignLine" | "bankSolid" | "barChartSolid" | "bookClosedSolid" | "bookmarkAddLine" | "bookmarkAddSolid" | "bookmarkCheckLine" | "bookmarkCheckSolid" | "bookmarkMinusLine" | "bookmarkMinusSolid" | "bookmarkXLine" | "bookmarkXSolid" | "bookmarkSolid" | "briefcaseSolid" | "building01Line" | "building01Solid" | "building02Line" | "building02Solid" | "calculatorSolid" | "calendarDateSolid" | "cameraSolid" | "chatCircleSolid" | "chevronSelectorVertical" | "circleChevronDownSolid" | "circleChevronLeftSolid" | "circleChevronRightSolid" | "circleChevronUpSolid" | "circleSwitchHorizontal01Solid" | "circleSwitchHorizontal02Solid" | "circleSwitchVertical02Solid" | "clockSolid" | "coinsHandSolid" | "coinsStackedSolid" | "copySolid" | "deleteSolid" | "edit01Solid" | "eyeOffSolid" | "eyeSolid" | "fileAttachmentSolid" | "fileChartSolid" | "fileDownloadSolid" | "fileSolid" | "folderSolid" | "giftSolid" | "graduationHatSolid" | "gridSolid" | "helpCircleLine" | "hourglassSolid" | "advisorFilled" | "advisorOutline" | "alertOctagon" | "amessage" | "archive" | "arrowDown" | "arrowUp" | "assetplus" | "attachFile" | "attachment" | "bank" | "barChart01" | "barChart02" | "bold" | "bond" | "book" | "bookmark" | "briefcase" | "bulb" | "calculator" | "calendar" | "camera" | "cartFilled" | "cartOutline" | "celebrate" | "chat" | "checkCircle" | "checkIntense" | "check" | "checkOutline" | "checklist" | "chevronUpDouble" | "circleOutline" | "clappingFilled" | "clapping" | "clock" | "close" | "closeOutline" | "coinsStacked" | "consultFilled" | "consultOutline" | "copy" | "copyNew" | "copyRights" | "creditCard" | "crossMark" | "delete" | "document" | "dotPoints" | "doubleCheck" | "downRound" | "down" | "downloadArrow" | "download" | "drag" | "edit" | "errorOutline" | "error" | "event" | "excel" | "exchangeFunds" | "eyeOff" | "eye" | "faq" | "favFilled" | "favOutline" | "fileAttachment" | "filter" | "folder" | "fundFinder" | "generate" | "gift" | "graduationHat" | "grid" | "handCoin" | "heartOutline" | "history" | "homeFilled" | "homeOutline" | "horizontalMore" | "hourglass" | "image" | "inbox" | "income" | "indicator" | "infoIntense" | "infoSubtle" | "info" | "insuranceFilled" | "insuranceOutline" | "investFilled" | "investOutline" | "italic" | "justiceScale" | "language" | "language02" | "language1" | "layers" | "leftArrow" | "left" | "likeFilled" | "lineChart" | "link" | "list" | "loader" | "loading" | "location" | "lock" | "logOut" | "loss" | "mail" | "marketing" | "media2" | "medicalCross" | "message" | "navigation" | "negativeIntense" | "negativeSubtle" | "noteTrash" | "notificationFilled" | "notificationOutline" | "notificationActiveFilled" | "notificationActiveOutline" | "passcode" | "pdf" | "pencilFilled" | "pencilOutline" | "phone" | "pin" | "play" | "plus" | "plusCircle" | "plusRounded" | "podcast" | "poster" | "ppt" | "profileDocument" | "profile" | "profit" | "radioOn" | "refreshDouble" | "refresh" | "report" | "retirement" | "right" | "rocketFilled" | "rocketOutline" | "rupee" | "save" | "scales" | "searchRefraction" | "search" | "send" | "settingsFilled" | "settingsOutline" | "shareTool" | "share" | "share02" | "shield" | "shop" | "sort" | "sparkles" | "starFilled" | "starOutline" | "strikeThrough" | "superStarter" | "support" | "switch" | "team" | "tickRound" | "tool01" | "tool" | "trash" | "truck" | "umbrella" | "underline" | "unlock" | "upRound" | "up" | "upload" | "userFilled" | "userOutline" | "userPlus" | "usersFilled" | "usersOutline" | "vault" | "verticalMore" | "video" | "view" | "wand" | "waringSubtle" | "warningIntense" | "warning" | "webinar" | "whatsapp" | "inboxSolid" | "infoCircle" | "infoSquareSolid" | "layersThreeSolid" | "lightbulbSolid" | "lockUnlockedSolid" | "lockSolid" | "logInLine" | "mailSolid" | "markerPinSolid" | "menuLine" | "messageChatSquareSolid" | "messageQuestionSquareSolid" | "mobilePhoneLine" | "mobilePhoneSolid" | "moonLine" | "moonSolid" | "passcodeSolid" | "pauseSquareLine" | "pauseSquareSolid" | "phoneSolid" | "pinSolid" | "playLine" | "posterSolid" | "refreshCw01Line" | "saveSolid" | "scalesSolid" | "sendSolid" | "share02Solid" | "shieldSolid" | "signalLine" | "signalSolid" | "switchHorizontal01Line" | "switchVertical01Line" | "targetSolid" | "tool01Solid" | "tool02Solid" | "trashSolid" | "tvSolid" | "umbrellaSolid" | "videoRecorderSolid" | "whatsappSolid" | "headphonesSolid" | "headphonesLine" | "messageTextSquareLine" | "archiveLine" | "arrowNarrowDown" | "arrowNarrowUp" | "attachmentLine" | "bankLine" | "barChart" | "barChartLine" | "bookClosedLine" | "bookmarkLine" | "briefcaseLine" | "lightbulbLine" | "calculatorLine" | "calendarDateLine" | "cameraLine" | "shoppingCartSolid" | "shoppingCartLine" | "chatCircleLine" | "checkCircleSolid" | "checkLine" | "checkCircleLine" | "clockLine" | "x" | "coinsStackedLine" | "messageTextSquareSolid" | "copyLine" | "deleteLine" | "fileLine" | "arrowCircleDownSolid" | "chevronDown" | "downloadLine" | "dragSolid" | "edit01Line" | "infoCircleLine" | "tvLine" | "eyeOffLine" | "eyeLine" | "messageQuestionSquareLine" | "starSolid" | "starLine" | "fileAttachmentLine" | "filterLines" | "folderLine" | "fundFinderLine" | "fileDownloadLine" | "giftLine" | "graduationHatLine" | "gridLine" | "coinsHandLine" | "heartRoundedLine" | "clockRewind" | "homeLine" | "homeSolid" | "dotsHorizontal" | "hourglassLine" | "inboxLine" | "targetLine" | "infoSquareLine" | "shieldTickSolid" | "shieldTickLine" | "currencyRupeeCircleSolid" | "currencyRupeeCircleLine" | "scalesLine" | "languageLine" | "layersThreeLine" | "arrowNarrowLeft" | "chevronLeft" | "heartRoundedSolid" | "lineChartUp" | "linkLine" | "dotPoints" | "loadingLine" | "markerPinLine" | "lockLine" | "logOutLine" | "mailLine" | "announcementLine" | "messageChatSquareLine" | "share01" | "bellSolid" | "bellLine" | "bellRingingSolid" | "bellRingingLine" | "passcodeLine" | "edit02Solid" | "edit02Line" | "phoneLine" | "pinLine" | "playSolid" | "plusLine" | "posterLine" | "refreshLeft" | "fileChartLine" | "chevronRight" | "rocketSolid" | "rocketLine" | "currencyRupee" | "saveLine" | "searchLine" | "sendLine" | "settingsSolid" | "settingsLine" | "share02Line" | "shieldLine" | "switchVertical02" | "helpCircleSolid" | "switchHorizontal02" | "tool01Line" | "tool02Line" | "trashLine" | "umbrellaLine" | "lockUnlockedLine" | "arrowCircleUpSolid" | "chevronUp" | "share03" | "userSolid" | "userLine" | "twoUsersSolid" | "twoUsersLine" | "vaultLine" | "dotsVertical" | "videoRecorderLine" | "magicWand" | "alertTriangleLine" | "whatsappLine" | "inflationGraph" | "insurancePerson" | "sendMessage"
    | "clockWarning"

function getIcon(icon: SVGIcon) {
    switch (icon) {
   case "activityLine": return <ActivityLine />;
   case "alertTriangleSolid": return <AlertTriangleSolid />;
   case "anchorLine": return <AnchorLine />;
   case "announcementSolid": return <AnnouncementSolid />;
   case "archiveSolid": return <ArchiveSolid />;
   case "arrowCircleBrokenDownLine": return <ArrowCircleBrokenDownLine />;
   case "arrowCircleBrokenDownSolid": return <ArrowCircleBrokenDownSolid />;
   case "arrowCircleBrokenLeftLine": return <ArrowCircleBrokenLeftLine />;
   case "arrowCircleBrokenLeftSolid": return <ArrowCircleBrokenLeftSolid />;
   case "arrowCircleBrokenRightLine": return <ArrowCircleBrokenRightLine />;
   case "arrowCircleBrokenRightSolid": return <ArrowCircleBrokenRightSolid />;
   case "arrowCircleBrokenUpLeftLine": return <ArrowCircleBrokenUpLeftLine />;
   case "arrowCircleBrokenUpLeftSolid": return <ArrowCircleBrokenUpLeftSolid />;
   case "arrowCircleBrokenUpRightLine": return <ArrowCircleBrokenUpRightLine />;
   case "arrowCircleBrokenUpRightSolid": return <ArrowCircleBrokenUpRightSolid />;
   case "arrowCircleBrokenUpLine": return <ArrowCircleBrokenUpLine />;
   case "arrowCircleBrokenUpSolid": return <ArrowCircleBrokenUpSolid />;
   case "arrowCircleDownLeftLine": return <ArrowCircleDownLeftLine />;
   case "arrowCircleDownLeftSolid": return <ArrowCircleDownLeftSolid />;
   case "arrowCircleDownRightLine": return <ArrowCircleDownRightLine />;
   case "arrowCircleDownRightSolid": return <ArrowCircleDownRightSolid />;
   case "arrowCircleDownLine": return <ArrowCircleDownLine />;
   case "arrowCircleLeftLine": return <ArrowCircleLeftLine />;
   case "arrowCircleLeftSolid": return <ArrowCircleLeftSolid />;
   case "arrowCircleRightLine": return <ArrowCircleRightLine />;
   case "arrowCircleRightSolid": return <ArrowCircleRightSolid />;
   case "arrowCircleUpLine": return <ArrowCircleUpLine />;
   case "arrowNarrowDownLeftLine": return <ArrowNarrowDownLeftLine />;
   case "arrowNarrowDownRightLine": return <ArrowNarrowDownRightLine />;
   case "arrowNarrowRightLine": return <ArrowNarrowRightLine />;
   case "arrowNarrowUpLeftLine": return <ArrowNarrowUpLeftLine />;
   case "arrowNarrowUpRightLine": return <ArrowNarrowUpRightLine />;
   case "arrowSquareDownLine": return <ArrowSquareDownLine />;
   case "arrowSquareDownSolid": return <ArrowSquareDownSolid />;
   case "arrowSquareLeftLine": return <ArrowSquareLeftLine />;
   case "arrowSquareLeftSolid": return <ArrowSquareLeftSolid />;
   case "arrowSquareRightLine": return <ArrowSquareRightLine />;
   case "arrowSquareRightSolid": return <ArrowSquareRightSolid />;
   case "arrowSquareUpLine": return <ArrowSquareUpLine />;
   case "arrowSquareUpSolid": return <ArrowSquareUpSolid />;
   case "asterisk01Line": return <Asterisk01Line />;
   case "asterisk02Line": return <Asterisk02Line />;
   case "atSignLine": return <AtSignLine />;
   case "bankSolid": return <BankSolid />;
   case "barChartSolid": return <BarChartSolid />;
   case "bookClosedSolid": return <BookClosedSolid />;
   case "bookmarkAddLine": return <BookmarkAddLine />;
   case "bookmarkAddSolid": return <BookmarkAddSolid />;
   case "bookmarkCheckLine": return <BookmarkCheckLine />;
   case "bookmarkCheckSolid": return <BookmarkCheckSolid />;
   case "bookmarkMinusLine": return <BookmarkMinusLine />;
   case "bookmarkMinusSolid": return <BookmarkMinusSolid />;
   case "bookmarkXLine": return <BookmarkXLine />;
   case "bookmarkXSolid": return <BookmarkXSolid />;
   case "bookmarkSolid": return <BookmarkSolid />;
   case "briefcaseSolid": return <BriefcaseSolid />;
   case "building01Line": return <Building01Line />;
   case "building01Solid": return <Building01Solid />;
   case "building02Line": return <Building02Line />;
   case "building02Solid": return <Building02Solid />;
   case "calculatorSolid": return <CalculatorSolid />;
   case "calendarDateSolid": return <CalendarDateSolid />;
   case "cameraSolid": return <CameraSolid />;
   case "chatCircleSolid": return <ChatCircleSolid />;
   case "chevronSelectorVertical": return <ChevronSelectorVertical />;
   case "circleChevronDownSolid": return <CircleChevronDownSolid />;
   case "circleChevronLeftSolid": return <CircleChevronLeftSolid />;
   case "circleChevronRightSolid": return <CircleChevronRightSolid />;
   case "circleChevronUpSolid": return <CircleChevronUpSolid />;
   case "circleSwitchHorizontal01Solid": return <CircleSwitchHorizontal01Solid />;
   case "circleSwitchHorizontal02Solid": return <CircleSwitchHorizontal02Solid />;
   case "circleSwitchVertical02Solid": return <CircleSwitchVertical02Solid />;
   case "clockSolid": return <ClockSolid />;
   case "coinsHandSolid": return <CoinsHandSolid />;
   case "coinsStackedSolid": return <CoinsStackedSolid />;
   case "copySolid": return <CopySolid />;
   case "deleteSolid": return <DeleteSolid />;
   case "edit01Solid": return <Edit01Solid />;
   case "eyeOffSolid": return <EyeOffSolid />;
   case "eyeSolid": return <EyeSolid />;
   case "fileAttachmentSolid": return <FileAttachmentSolid />;
   case "fileChartSolid": return <FileChartSolid />;
   case "fileDownloadSolid": return <FileDownloadSolid />;
   case "fileSolid": return <FileSolid />;
   case "folderSolid": return <FolderSolid />;
   case "giftSolid": return <GiftSolid />;
   case "graduationHatSolid": return <GraduationHatSolid />;
   case "gridSolid": return <GridSolid />;
   case "helpCircleLine": return <HelpCircleLine />;
   case "hourglassSolid": return <HourglassSolid />;
   case "advisorFilled": return <AdvisorFilled />;
   case "advisorOutline": return <AdvisorOutline />;
   case "alertOctagon": return <AlertOctagon />;
   case "amessage": return <Amessage />;
   case "archive": return <Archive />;
   case "arrowDown": return <ArrowDown />;
   case "arrowUp": return <ArrowUp />;
   case "assetplus": return <Assetplus />;
   case "attachFile": return <AttachFile />;
   case "attachment": return <Attachment />;
   case "bank": return <Bank />;
   case "barChart01": return <BarChart01 />;
   case "barChart02": return <BarChart02 />;
   case "bold": return <Bold />;
   case "bond": return <Bond />;
   case "book": return <Book />;
   case "bookmark": return <Bookmark />;
   case "briefcase": return <Briefcase />;
   case "bulb": return <Bulb />;
   case "calculator": return <Calculator />;
   case "calendar": return <Calendar />;
   case "camera": return <Camera />;
   case "cartFilled": return <CartFilled />;
   case "cartOutline": return <CartOutline />;
   case "celebrate": return <Celebrate />;
   case "chat": return <Chat />;
   case "checkCircle": return <CheckCircle />;
   case "clockWarning": return <ClockWarning />;
   case "checkIntense": return <CheckIntense />;
   case "check": return <Check />;
   case "checkOutline": return <CheckOutline />;
   case "checklist": return <Checklist />;
   case "chevronUpDouble": return <ChevronUpDouble />;
   case "circleOutline": return <CircleOutline />;
   case "clappingFilled": return <ClappingFilled />;
   case "clapping": return <Clapping />;
   case "clock": return <Clock />;
   case "close": return <Close />;
   case "closeOutline": return <CloseOutline />;
   case "coinsStacked": return <CoinsStacked />;
   case "consultFilled": return <ConsultFilled />;
   case "consultOutline": return <ConsultOutline />;
   case "copy": return <Copy />;
   case "copyNew": return <CopyNew />;
   case "copyRights": return <CopyRights />;
   case "creditCard": return <CreditCard />;
   case "crossMark": return <CrossMark />;
   case "delete": return <Delete />;
   case "document": return <Document />;
   case "dotPoints": return <DotPoints />;
   case "doubleCheck": return <DoubleCheck />;
   case "downRound": return <DownRound />;
   case "down": return <Down />;
   case "downloadArrow": return <DownloadArrow />;
   case "download": return <Download />;
   case "drag": return <Drag />;
   case "edit": return <Edit />;
   case "errorOutline": return <ErrorOutline />;
   case "error": return <Error />;
   case "event": return <Event />;
   case "excel": return <Excel />;
   case "exchangeFunds": return <ExchangeFunds />;
   case "eyeOff": return <EyeOff />;
   case "eye": return <Eye />;
   case "faq": return <Faq />;
   case "favFilled": return <FavFilled />;
   case "favOutline": return <FavOutline />;
   case "fileAttachment": return <FileAttachment />;
   case "filter": return <Filter />;
   case "folder": return <Folder />;
   case "fundFinder": return <FundFinder />;
   case "generate": return <Generate />;
   case "gift": return <Gift />;
   case "graduationHat": return <GraduationHat />;
   case "grid": return <Grid />;
   case "handCoin": return <HandCoin />;
   case "heartOutline": return <HeartOutline />;
   case "history": return <History />;
   case "homeFilled": return <HomeFilled />;
   case "homeOutline": return <HomeOutline />;
   case "horizontalMore": return <HorizontalMore />;
   case "hourglass": return <Hourglass />;
   case "image": return <Image />;
   case "inbox": return <Inbox />;
   case "income": return <Income />;
   case "indicator": return <Indicator />;
   case "infoIntense": return <InfoIntense />;
   case "infoSubtle": return <InfoSubtle />;
   case "info": return <Info />;
   case "insuranceFilled": return <InsuranceFilled />;
   case "insuranceOutline": return <InsuranceOutline />;
   case "investFilled": return <InvestFilled />;
   case "investOutline": return <InvestOutline />;
   case "italic": return <Italic />;
   case "justiceScale": return <JusticeScale />;
   case "language": return <Language />;
   case "language02": return <Language02 />;
   case "language1": return <Language1 />;
   case "layers": return <Layers />;
   case "leftArrow": return <LeftArrow />;
   case "left": return <Left />;
   case "likeFilled": return <LikeFilled />;
   case "lineChart": return <LineChart />;
   case "link": return <Link />;
   case "list": return <List />;
   case "loader": return <Loader />;
   case "loading": return <Loading />;
   case "location": return <Location />;
   case "lock": return <Lock />;
   case "logOut": return <LogOut />;
   case "loss": return <Loss />;
   case "mail": return <Mail />;
   case "marketing": return <Marketing />;
   case "media2": return <Media2 />;
   case "medicalCross": return <MedicalCross />;
   case "message": return <Message />;
   case "navigation": return <Navigation />;
   case "negativeIntense": return <NegativeIntense />;
   case "negativeSubtle": return <NegativeSubtle />;
   case "noteTrash": return <NoteTrash />;
   case "notificationFilled": return <NotificationFilled />;
   case "notificationOutline": return <NotificationOutline />;
   case "notificationActiveFilled": return <NotificationActiveFilled />;
   case "notificationActiveOutline": return <NotificationActiveOutline />;
   case "passcode": return <Passcode />;
   case "pdf": return <Pdf />;
   case "pencilFilled": return <PencilFilled />;
   case "pencilOutline": return <PencilOutline />;
   case "phone": return <Phone />;
   case "pin": return <Pin />;
   case "play": return <Play />;
   case "plus": return <Plus />;
   case "plusCircle": return <PlusCircle />;
   case "plusRounded": return <PlusRounded />;
   case "podcast": return <Podcast />;
   case "poster": return <Poster />;
   case "ppt": return <Ppt />;
   case "profileDocument": return <ProfileDocument />;
   case "profile": return <Profile />;
   case "profit": return <Profit />;
   case "radioOn": return <RadioOn />;
   case "refreshDouble": return <RefreshDouble />;
   case "refresh": return <Refresh />;
   case "report": return <Report />;
   case "retirement": return <Retirement />;
   case "right": return <Right />;
   case "rocketFilled": return <RocketFilled />;
   case "rocketOutline": return <RocketOutline />;
   case "rupee": return <Rupee />;
   case "save": return <Save />;
   case "scales": return <Scales />;
   case "searchRefraction": return <SearchRefraction />;
   case "search": return <Search />;
   case "send": return <Send />;
   case "settingsFilled": return <SettingsFilled />;
   case "settingsOutline": return <SettingsOutline />;
   case "shareTool": return <ShareTool />;
   case "share": return <Share />;
   case "share02": return <Share02 />;
   case "shield": return <Shield />;
   case "shop": return <Shop />;
   case "sort": return <Sort />;
   case "sparkles": return <Sparkles />;
   case "starFilled": return <StarFilled />;
   case "starOutline": return <StarOutline />;
   case "strikeThrough": return <StrikeThrough />;
   case "superStarter": return <SuperStarter />;
   case "support": return <Support />;
   case "switch": return <Switch />;
   case "team": return <Team />;
   case "tickRound": return <TickRound />;
   case "tool01": return <Tool01 />;
   case "tool": return <Tool />;
   case "trash": return <Trash />;
   case "truck": return <Truck />;
   case "umbrella": return <Umbrella />;
   case "underline": return <Underline />;
   case "unlock": return <Unlock />;
   case "upRound": return <UpRound />;
   case "up": return <Up />;
   case "upload": return <Upload />;
   case "userFilled": return <UserFilled />;
   case "userOutline": return <UserOutline />;
   case "userPlus": return <UserPlus />;
   case "usersFilled": return <UsersFilled />;
   case "usersOutline": return <UsersOutline />;
   case "vault": return <Vault />;
   case "verticalMore": return <VerticalMore />;
   case "video": return <Video />;
   case "view": return <View />;
   case "wand": return <Wand />;
   case "waringSubtle": return <WaringSubtle />;
   case "warningIntense": return <WarningIntense />;
   case "warning": return <Warning />;
   case "webinar": return <Webinar />;
   case "whatsapp": return <Whatsapp />;
   case "inflationGraph": return <InflationGraph />;
   case "insurancePerson": return <InsurancePerson />;
   case "sendMessage": return <SendMessage />;
   case "inboxSolid": return <InboxSolid />;
   case "infoCircle": return <InfoCircle />;
   case "infoSquareSolid": return <InfoSquareSolid />;
   case "layersThreeSolid": return <LayersThreeSolid />;
   case "lightbulbSolid": return <LightbulbSolid />;
   case "lockUnlockedSolid": return <LockUnlockedSolid />;
   case "lockSolid": return <LockSolid />;
   case "logInLine": return <LogInLine />;
   case "mailSolid": return <MailSolid />;
   case "markerPinSolid": return <MarkerPinSolid />;
   case "menuLine": return <MenuLine />;
   case "messageChatSquareSolid": return <MessageChatSquareSolid />;
   case "messageQuestionSquareSolid": return <MessageQuestionSquareSolid />;
   case "mobilePhoneLine": return <MobilePhoneLine />;
   case "mobilePhoneSolid": return <MobilePhoneSolid />;
   case "moonLine": return <MoonLine />;
   case "moonSolid": return <MoonSolid />;
   case "passcodeSolid": return <PasscodeSolid />;
   case "pauseSquareLine": return <PauseSquareLine />;
   case "pauseSquareSolid": return <PauseSquareSolid />;
   case "phoneSolid": return <PhoneSolid />;
   case "pinSolid": return <PinSolid />;
   case "playLine": return <PlayLine />;
   case "posterSolid": return <PosterSolid />;
   case "refreshCw01Line": return <RefreshCw01Line />;
   case "saveSolid": return <SaveSolid />;
   case "scalesSolid": return <ScalesSolid />;
   case "sendSolid": return <SendSolid />;
   case "share02Solid": return <Share02Solid />;
   case "shieldSolid": return <ShieldSolid />;
   case "signalLine": return <SignalLine />;
   case "signalSolid": return <SignalSolid />;
   case "switchHorizontal01Line": return <SwitchHorizontal01Line />;
   case "switchVertical01Line": return <SwitchVertical01Line />;
   case "targetSolid": return <TargetSolid />;
   case "tool01Solid": return <Tool01Solid />;
   case "tool02Solid": return <Tool02Solid />;
   case "trashSolid": return <TrashSolid />;
   case "tvSolid": return <TvSolid />;
   case "umbrellaSolid": return <UmbrellaSolid />;
   case "videoRecorderSolid": return <VideoRecorderSolid />;
   case "whatsappSolid": return <WhatsappSolid />;
   case "headphonesSolid": return <AdvisorFilled />;
   case "headphonesLine": return <AdvisorOutline />;
   case "messageTextSquareLine": return <Amessage />;
   case "archiveLine": return <Archive />;
   case "arrowNarrowDown": return <ArrowDown />;
   case "arrowNarrowUp": return <ArrowUp />;
   case "attachmentLine": return <Attachment />;
   case "bankLine": return <Bank />;
   case "barChart": return <BarChart01 />;
   case "barChartLine": return <BarChart02 />;
   case "bookClosedLine": return <Book />;
   case "bookmarkLine": return <Bookmark />;
   case "briefcaseLine": return <Briefcase />;
   case "lightbulbLine": return <Bulb />;
   case "calculatorLine": return <Calculator />;
   case "calendarDateLine": return <Calendar />;
   case "cameraLine": return <Camera />;
   case "shoppingCartSolid": return <CartFilled />;
   case "shoppingCartLine": return <CartOutline />;
   case "chatCircleLine": return <Chat />;
   case "checkCircleSolid": return <CheckCircle />;
   case "checkLine": return <Check />;
   case "checkCircleLine": return <CheckOutline />;
   case "clockLine": return <Clock />;
   case "x": return <Close />;
   case "coinsStackedLine": return <CoinsStacked />;
   case "messageTextSquareSolid": return <ConsultFilled />;
   case "copyLine": return <Copy />;
   case "deleteLine": return <Delete />;
   case "fileLine": return <Document />;
   case "arrowCircleDownSolid": return <DownRound />;
   case "chevronDown": return <Down />;
   case "downloadLine": return <Download />;
   case "dragSolid": return <Drag />;
   case "edit01Line": return <Edit />;
   case "infoCircleLine": return <ErrorOutline />;
   case "tvLine": return <Event />;
   case "eyeOffLine": return <EyeOff />;
   case "eyeLine": return <Eye />;
   case "messageQuestionSquareLine": return <Faq />;
   case "starSolid": return <FavFilled />;
   case "starLine": return <FavOutline />;
   case "fileAttachmentLine": return <FileAttachment />;
   case "filterLines": return <Filter />;
   case "folderLine": return <Folder />;
   case "fundFinderLine": return <FundFinder />;
   case "fileDownloadLine": return <Generate />;
   case "giftLine": return <Gift />;
   case "graduationHatLine": return <GraduationHat />;
   case "gridLine": return <Grid />;
   case "coinsHandLine": return <HandCoin />;
   case "heartRoundedLine": return <HeartOutline />;
   case "clockRewind": return <History />;
   case "homeLine": return <HomeOutline />;
   case "homeSolid": return <HomeFilled />;
   case "dotsHorizontal": return <HorizontalMore />;
   case "hourglassLine": return <Hourglass />;
   case "inboxLine": return <Inbox />;
   case "targetLine": return <Indicator />;
   case "infoSquareLine": return <Info />;
   case "shieldTickSolid": return <InsuranceFilled />;
   case "shieldTickLine": return <InsuranceOutline />;
   case "currencyRupeeCircleSolid": return <InvestFilled />;
   case "currencyRupeeCircleLine": return <InvestOutline />;
   case "scalesLine": return <JusticeScale />;
   case "languageLine": return <Language02 />;
   case "layersThreeLine": return <Layers />;
   case "arrowNarrowLeft": return <LeftArrow />;
   case "chevronLeft": return <Left />;
   case "heartRoundedSolid": return <LikeFilled />;
   case "lineChartUp": return <LineChart />;
   case "linkLine": return <Link />;
   case "dotPoints": return <List />;
   case "loadingLine": return <Loading />;
   case "markerPinLine": return <Location />;
   case "lockLine": return <Lock />;
   case "logOutLine": return <LogOut />;
   case "mailLine": return <Mail />;
   case "announcementLine": return <Marketing />;
   case "messageChatSquareLine": return <Message />;
   case "share01": return <Navigation />;
   case "bellSolid": return <NotificationFilled />;
   case "bellLine": return <NotificationOutline />;
   case "bellRingingSolid": return <NotificationActiveFilled />;
   case "bellRingingLine": return <NotificationActiveOutline />;
   case "passcodeLine": return <Passcode />;
   case "edit02Solid": return <PencilFilled />;
   case "edit02Line": return <PencilOutline />;
   case "phoneLine": return <Phone />;
   case "pinLine": return <Pin />;
   case "playSolid": return <Play />;
   case "plusLine": return <Plus />;
   case "posterLine": return <Poster />;
   case "refreshLeft": return <Refresh />;
   case "fileChartLine": return <Report />;
   case "chevronRight": return <Right />;
   case "rocketSolid": return <RocketFilled />;
   case "rocketLine": return <RocketOutline />;
   case "currencyRupee": return <Rupee />;
   case "saveLine": return <Save />;
   case "searchLine": return <Search />;
   case "sendLine": return <Send />;
   case "settingsSolid": return <SettingsFilled />;
   case "settingsLine": return <SettingsOutline />;
   case "share02Line": return <ShareTool />;
   case "shieldLine": return <Shield />;
   case "switchVertical02": return <Sort />;
   case "helpCircleSolid": return <Support />;
   case "switchHorizontal02": return <Switch />;
   case "tool01Line": return <Tool01 />;
   case "tool02Line": return <Tool />;
   case "trashLine": return <Trash />;
   case "umbrellaLine": return <Umbrella />;
   case "lockUnlockedLine": return <Unlock />;
   case "arrowCircleUpSolid": return <UpRound />;
   case "chevronUp": return <Up />;
   case "share03": return <Upload />;
   case "userSolid": return <UserFilled />;
   case "userLine": return <UserOutline />;
   case "twoUsersSolid": return <UsersFilled />;
   case "twoUsersLine": return <UsersOutline />;
   case "vaultLine": return <Vault />;
   case "dotsVertical": return <VerticalMore />;
   case "videoRecorderLine": return <Video />;
   case "magicWand": return <Wand />;
   case "alertTriangleLine": return <Warning />;
   case "whatsappLine": return <Whatsapp />;
default:
            return <div></div>
    }
}

interface APIconProps {
    icon: SVGIcon,
    /**
     * @default 24
     */
    size?: number,
    /**
     * @default APPalette['grey-700']
     */
    color?: string,
    /**
     * @default 0
     */
}

export function APIcon({ icon, size = 24, color = APPalette['grey-700'] }: APIconProps) {
    return React.cloneElement(getIcon(icon), { color: color, width: size, height: size })
}
